import axios, { AxiosResponse } from "axios";
import { TypeRequest } from "../common/enums/AllEnums";

export const BisAPI = axios.create();

export const BisApiRequest = async (url: string, type: TypeRequest, body?: any) => {
    let { data } = await axios.get(process.env.PUBLIC_URL + "/apiUrl.json");
    BisAPI.defaults.baseURL = data?.apiUrl;

    let request;

    switch (type) {
        case TypeRequest.get:
            request = BisAPI.get(url);
            break;
        case TypeRequest.post:
            request = BisAPI.post(url, body);
            break;
        case TypeRequest.put:
            request = BisAPI.put(url, body);
            break;
        case TypeRequest.delete:
            request = BisAPI.delete(url);
            break;
    }
    return request;
}


